var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4176 9.30398L15.0646 10.6065H8.46733L8.82528 9.30398H15.4176ZM12.1016 17L8.62145 12.8139L8.61648 11.7102H10.3366C10.7476 11.7102 11.0907 11.6423 11.3658 11.5064C11.6442 11.3672 11.8546 11.1733 11.9972 10.9247C12.143 10.6728 12.2159 10.3778 12.2159 10.0398C12.2159 9.53267 12.0668 9.125 11.7685 8.81676C11.4702 8.50852 10.9929 8.3544 10.3366 8.3544H8.46733L8.85511 6.81818H10.3366C11.1719 6.81818 11.8629 6.94744 12.4098 7.20597C12.96 7.46117 13.371 7.82244 13.6428 8.28977C13.9179 8.7571 14.0554 9.30398 14.0554 9.9304C14.0554 10.4839 13.9543 10.9777 13.7521 11.4119C13.55 11.8461 13.2318 12.2024 12.7976 12.4808C12.3634 12.7592 11.795 12.9448 11.0923 13.0376L11.0327 13.0575L14.1747 16.9105V17H12.1016ZM15.4276 6.81818L15.0646 8.14062L9.7152 8.12074L10.0781 6.81818H15.4276Z",
    fill: "#00254A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2",
    stroke: "#00254A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.41f1bf214a3546ccb34c1fd0588bd9e4.svg";
export { ForwardRef as ReactComponent };